import React from 'react';

import { DescriptionContainer } from './PreviewedFileDescription.styled';
import { Text } from 'components/v2/Typography/Text';

export const PreviewedFileDescription = ({
  extensions,
  maxSize
}: {
  extensions: string;
  maxSize: string;
}) => (
  <DescriptionContainer>
    <Text tag="p">{extensions}</Text>

    <Text tag="p">{maxSize}</Text>
  </DescriptionContainer>
);
